export const boxSizes = [
  { length: 4, width: 4, height: 4, minOrderQty: 25, priceEach: 0.54 },
  { length: 4, width: 4, height: 5, minOrderQty: 25, priceEach: 0.52 },
  { length: 5, width: 5, height: 3, minOrderQty: 25, priceEach: 0.54 },
  { length: 5, width: 5, height: 4, minOrderQty: 25, priceEach: 0.57 },
  { length: 5, width: 5, height: 5, minOrderQty: 25, priceEach: 0.6 },
  { length: 5, width: 5, height: 10, minOrderQty: 25, priceEach: 0.86 },
  { length: 6, width: 4, height: 4, minOrderQty: 25, priceEach: 0.54 },
  { length: 6, width: 5, height: 4, minOrderQty: 25, priceEach: 0.6 },
  { length: 6, width: 5, height: 5, minOrderQty: 25, priceEach: 0.63 },
  { length: 6, width: 6, height: 2, minOrderQty: 25, priceEach: 0.59 },
  { length: 6, width: 6, height: 3, minOrderQty: 25, priceEach: 0.63 },
  { length: 6, width: 6, height: 4, minOrderQty: 25, priceEach: 0.66 },
  { length: 6, width: 6, height: 5, minOrderQty: 25, priceEach: 0.8 },
  { length: 6, width: 6, height: 6, minOrderQty: 25, priceEach: 0.64 },
  { length: 7, width: 5, height: 3, minOrderQty: 25, priceEach: 0.59 },
  { length: 7, width: 5, height: 5, minOrderQty: 25, priceEach: 0.66 },
  { length: 7, width: 6, height: 4, minOrderQty: 25, priceEach: 0.79 },
  { length: 7, width: 7, height: 3, minOrderQty: 25, priceEach: 0.82 },
  { length: 7, width: 7, height: 4, minOrderQty: 25, priceEach: 0.87 },
  { length: 7, width: 7, height: 5, minOrderQty: 25, priceEach: 0.91 },
  { length: 7, width: 7, height: 6, minOrderQty: 25, priceEach: 0.95 },
  { length: 7, width: 7, height: 7, minOrderQty: 25, priceEach: 1.09 },
  { length: 7, width: 7, height: 8, minOrderQty: 25, priceEach: 1.14 },
  { length: 7, width: 7, height: 10, minOrderQty: 25, priceEach: 1.22 },
  { length: 8, width: 5, height: 4, minOrderQty: 25, priceEach: 0.65 },
  { length: 8, width: 5, height: 5, minOrderQty: 25, priceEach: 0.79 },
  { length: 8, width: 6, height: 3, minOrderQty: 25, priceEach: 0.78 },
  { length: 8, width: 6, height: 4, minOrderQty: 25, priceEach: 0.82 },
  { length: 8, width: 6, height: 5, minOrderQty: 25, priceEach: 0.84 },
  { length: 8, width: 6, height: 6, minOrderQty: 25, priceEach: 0.91 },
  { length: 8, width: 8, height: 3, minOrderQty: 25, priceEach: 0.93 },
  { length: 8, width: 8, height: 4, minOrderQty: 25, priceEach: 1.14 },
  { length: 8, width: 8, height: 5, minOrderQty: 25, priceEach: 1.13 },
  { length: 8, width: 8, height: 6, minOrderQty: 25, priceEach: 1.18 },
  { length: 8, width: 8, height: 7, minOrderQty: 25, priceEach: 1.22 },
  { length: 8, width: 8, height: 8, minOrderQty: 25, priceEach: 1.3 },
  { length: 9, width: 4, height: 3, minOrderQty: 25, priceEach: 0.57 },
  { length: 9, width: 4, height: 4, minOrderQty: 25, priceEach: 0.61 },
  { length: 9, width: 5, height: 3, minOrderQty: 25, priceEach: 0.64 },
  { length: 9, width: 5, height: 5, minOrderQty: 25, priceEach: 0.82 },
  { length: 9, width: 6, height: 2, minOrderQty: 25, priceEach: 0.66 },
  { length: 9, width: 6, height: 3, minOrderQty: 25, priceEach: 0.81 },
  { length: 9, width: 6, height: 4, minOrderQty: 25, priceEach: 0.84 },
  { length: 10, width: 6, height: 4, minOrderQty: 25, priceEach: 0.88 },
  { length: 10, width: 6, height: 6, minOrderQty: 25, priceEach: 1.08 },
  { length: 10, width: 7, height: 4, minOrderQty: 25, priceEach: 0.96 },
  { length: 10, width: 7, height: 5, minOrderQty: 25, priceEach: 1.11 },
  { length: 10, width: 7, height: 7, minOrderQty: 25, priceEach: 1.22 },
  { length: 10, width: 8, height: 4, minOrderQty: 25, priceEach: 1.15 },
  { length: 10, width: 8, height: 5, minOrderQty: 25, priceEach: 1.2 },
  { length: 10, width: 8, height: 6, minOrderQty: 25, priceEach: 1.26 },
  { length: 10, width: 8, height: 7, minOrderQty: 25, priceEach: 1.41 },
  { length: 10, width: 8, height: 8, minOrderQty: 25, priceEach: 1.47 },
  { length: 10, width: 9, height: 6, minOrderQty: 25, priceEach: 1.46 },
  { length: 10, width: 9, height: 8, minOrderQty: 25, priceEach: 1.57 },
  { length: 10, width: 9, height: 9, minOrderQty: 25, priceEach: 1.73 },
  { length: 10, width: 10, height: 3, minOrderQty: 25, priceEach: 1.38 },
  { length: 10, width: 10, height: 4, minOrderQty: 25, priceEach: 1.44 },
  { length: 10, width: 10, height: 5, minOrderQty: 25, priceEach: 1.5 },
  { length: 10, width: 10, height: 6, minOrderQty: 25, priceEach: 1.56 },
  { length: 10, width: 10, height: 7, minOrderQty: 25, priceEach: 1.72 },
  { length: 10, width: 10, height: 8, minOrderQty: 25, priceEach: 1.78 },
  { length: 10, width: 10, height: 9, minOrderQty: 25, priceEach: 1.84 },
  { length: 10, width: 10, height: 10, minOrderQty: 25, priceEach: 1.9 },
  { length: 10, width: 10, height: 12, minOrderQty: 25, priceEach: 2.07 },
  { length: 10, width: 10, height: 15, minOrderQty: 25, priceEach: 2.45 },
  { length: 11, width: 6, height: 4, minOrderQty: 25, priceEach: 0.91 },
  { length: 12, width: 9, height: 4, minOrderQty: 25, priceEach: 1.33 },
  { length: 12, width: 10, height: 4, minOrderQty: 25, priceEach: 1.52 },
  { length: 12, width: 10, height: 6, minOrderQty: 25, priceEach: 1.75 },
  { length: 12, width: 10, height: 8, minOrderQty: 25, priceEach: 1.88 },
  { length: 12, width: 10, height: 9, minOrderQty: 25, priceEach: 1.95 },
  { length: 12, width: 10, height: 10, minOrderQty: 25, priceEach: 2.06 },
  { length: 12, width: 11, height: 4, minOrderQty: 25, priceEach: 1.73 },
  { length: 12, width: 12, height: 2, minOrderQty: 25, priceEach: 1.7 },
  { length: 12, width: 12, height: 3, minOrderQty: 25, priceEach: 1.78 },
  { length: 12, width: 12, height: 4, minOrderQty: 25, priceEach: 1.85 },
  { length: 12, width: 12, height: 5, minOrderQty: 25, priceEach: 1.92 },
  { length: 12, width: 12, height: 6, minOrderQty: 25, priceEach: 2.04 },
  { length: 12, width: 12, height: 7, minOrderQty: 25, priceEach: 2.11 },
  { length: 12, width: 12, height: 8, minOrderQty: 25, priceEach: 2.23 },
  { length: 12, width: 12, height: 9, minOrderQty: 25, priceEach: 2.3 },
  { length: 12, width: 12, height: 10, minOrderQty: 25, priceEach: 2.37 },
  { length: 12, width: 12, height: 11, minOrderQty: 25, priceEach: 2.69 },
  { length: 12, width: 12, height: 12, minOrderQty: 25, priceEach: 2.1 },
  { length: 12, width: 12, height: 15, minOrderQty: 25, priceEach: 2.98 },
  { length: 12, width: 12, height: 20, minOrderQty: 15, priceEach: 4.3 },
  { length: 12, width: 12, height: 24, minOrderQty: 15, priceEach: 4.26 },
  { length: 12, width: 12, height: 30, minOrderQty: 10, priceEach: 5.7 },
  { length: 20, width: 20, height: 4, minOrderQty: 10, priceEach: 5.4 },
  { length: 22, width: 22, height: 4, minOrderQty: 10, priceEach: 5.9 },
];
